import type { ThemeConfig } from '../types'
import { canopyConfig as generated } from '../../generated/theme-presets'

// Canopy: SOFT NEUMORPHISM. No borders anywhere. Every surface looks gently pressed
// into or raised from the page, like moss growing on stone. Paired light/dark shadows
// create depth without edges. Super-rounded, pillow-soft corners. Light heading weight
// because nothing here is trying too hard. Wide sidebar, generous spacing, the UI
// equivalent of a forest floor — everything just... belongs.
export const canopyConfig: ThemeConfig = generated
